'use client';

import React, { FC, useEffect, useState } from 'react';
import styles from '../header.module.scss';
import { PlayButton } from '../../../../ui/play-button/play-button';
import { Search } from '../search';
import { AudioPlayerItems } from '../../../../../libs/types/audio.types';
import { WidgetBlind } from '../widget-blind/widget-blind';

interface SectionPlaySearchBlindProps {
  live: AudioPlayerItems;
}

export const SectionPlaySearchBlind: FC<SectionPlaySearchBlindProps> = ({ live }) => {
  const [showEye, setShowEye] = useState(true);
  const [hiddenInput, setHiddenInput] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 640) {
      setShowEye(false);
    }
  }, []);

  return (
    <section className={styles.rest}>
      <PlayButton
        text={'Прямой эфир'}
        track={live}
        className={styles.buttonPad}
        radioBtn={true}
      />
      {showEye && <WidgetBlind style={hiddenInput ? { display: 'none' } : undefined} />}
      <Search hiddenInput={hiddenInput} setHiddenInput={setHiddenInput} /> {/* Поиск */}
    </section>
  );
};
